/**
 * Check if an Azure AD error indicates an expired authorization code
 * that requires clearing state and starting fresh
 */
export function isExpiredAuthCodeError(error: unknown): boolean {
  if (!error) return false;

  const errorString = error instanceof Error ? error.message : String(error);

  // AADSTS70008: Authorization code or refresh token expired
  return (
    errorString.includes('AADSTS70008') ||
    errorString.includes('expired due to inactivity')
  );
}

/**
 * Check if an error indicates the auth code was already redeemed
 * (common with React StrictMode double-mounting)
 */
export function isCodeAlreadyRedeemedError(error: unknown): boolean {
  if (!error) return false;

  const errorString = error instanceof Error ? error.message : String(error);

  // AADSTS54005: OAuth2 Authorization code was already redeemed
  return (
    errorString.includes('AADSTS54005') ||
    errorString.includes('already redeemed')
  );
}
